const AuthHeader = () => {

    return(
        <div>
            <h2 className="is-3">We just need a few details</h2>
            <p>To save content from the prospectus, we'll need a few details from you!</p>
        </div>
    )
}

export default AuthHeader;